import { render, staticRenderFns } from "./Assaigment.vue?vue&type=template&id=6f00e9b0&"
import script from "./Assaigment.vue?vue&type=script&lang=js&"
export * from "./Assaigment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports